
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Wenn Trostformen nicht mehr klassisch religiös angeboten werden, wird der Himmel
meist umgehend neu möbliert. Darin leben die klassisch religiösen Trost- und
Deutungsformen weiter: Mythen, deren wiederholte Aufführung als Reenacting,
Rituale und sakrale Handlungen. Sie sind darauf angelegt, in
ins­titutionalisierter Form Trost zu spenden, im Idealfall sogar zu heilen oder
zu befreien. Wenn die Religion durch naturwissenschaftliche Widerlegung ihre
Rolle verliert, heisst dies folglich nicht, dass auch dieses Trostangebot
verloren gehen muss. Es müsste aber kognitiv vereinbar sein mit dem aktuellen
Stand der Naturwissenschaft und moralisch mit den Eckpfeilern einer modernen
Gerechtigkeitslehre, die sich an der Chancengleichheit orientiert.`}</p>
    <p>{`Mythen sind dazu nur bedingt tauglich, weil sie für die reflexartige Wahrnehmung
des Weltgeschehens mitverantwortlich sind. Die sofortige Einordnung eines
Ereignisses aufgrund eines durch Mythen geprägten Weltbildes («Framing») ist in
der Regel deutlich stärker als Fakten. Ausserdem sind Mythen perfekte Baustoffe
für politische Verführung im Populismus. Begriffe wie Volk, Heimat oder Nation
werden dazu ideologisch aufgeladen. Rituale und spirituelle Handlungen sind
demgegenüber politisch und religiös neutraler.`}</p>
    <p>{`Gegen die Neumöblierung des Himmels ist nichts einzuwenden, solange sie nicht
auf abstrusem Hokuspokus beruht, gegenüber Un- oder Andersgläubigen nicht
ausgrenzend ist und nicht zu einem verklärenden Fanatismus führt. Die
Schadensskala reicht hier von gross (für fanatische Sekten oder einen
idealisierten, ausgrenzenden Nationalismus), über mittel (für verunklärende
Esoterik) bis klein oder gar nützlich wie im Fall der Homöopathie.
Naturwissenschaftlich ist eine Wirkung der tausendfach verdünnten Substanzen in
der rituellen Einnahmeform von Kügelchen nicht nachzuweisen; es bleiben der
Placebo-Effekt und die mit der Homöopathie verbundene ganzheitliche Achtsamkeit
gegenüber Störungen im Organismus. Plakativ formuliert: Globuli gegen die
Globalisierung – wenn man den weltwirtschaftlichen Druck, arbeitsmarktfähig zu
bleiben, als Krankheitsursache wahrnimmt. Die Aktualität einer idealistisch
überhöhten Nation ist eine Nebenwirkung des leer geräumten Himmels. Mit ihr
lässt sich die Angst vor dem individuellen Tod genauso wirksam verscheuchen wie
mit der Vorstellung von Seelenwanderung. Die Seele eines quasireligiös fühlenden
Nationalisten wird in der Vorstellung ihres Trägers im Kollektiv einer von
Mythen unterlegten ewigen Nation weiterleben. Das erklärt auch die vergleichbare
Vehemenz und Uner­bittlichkeit in den Konflikten zwischen Nationen wie in jenen
zwischen Religionen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;